import { Box, Typography, styled } from '@mui/material'

import { IProductConfiguration } from '@/types'
import { EligibilityRules } from './EligibilityRules'
import { formatPercentageRange, formatText } from './format'

// The row already shows name, key, status, version, limits, term and interest
// rate, so the panel carries what is left rather than repeating them.
export const ProductDetail = ({ product }: { product: IProductConfiguration }) => {
  const details: [string, string][] = [
    ['Description', formatText(product.description)],
    [
      'Interest Rate Range',
      formatPercentageRange(product.minInterestRate, product.maxInterestRate),
    ],
    ['Write Off Days', formatText(product.writeOffDays)],
  ]

  return (
    <Panel>
      <SectionTitle>Product Details</SectionTitle>
      <DetailGrid>
        {details.map(([label, value]) => (
          <Box key={label}>
            <Label>{label}</Label>
            <Value>{value}</Value>
          </Box>
        ))}
      </DetailGrid>

      <SectionTitle sx={{ mt: 3 }}>Eligibility Rules</SectionTitle>
      <EligibilityRules productName={product.name} rules={product.eligibilityRules ?? []} />
    </Panel>
  )
}

const Panel = styled(Box)({
  backgroundColor: '#F9FAFB',
  borderTop: '1px solid #EAECF0',
  padding: '16px 24px 24px',
})

const SectionTitle = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Inter',
  fontWeight: 600,
  color: '#101828',
  marginBottom: '12px',
})

const DetailGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  gap: '12px 24px',
  marginBottom: '8px',
})

const Label = styled(Typography)({
  fontSize: '12px',
  fontFamily: 'Inter',
  color: '#98A2B3',
})

const Value = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Inter',
  color: '#475467',
  wordBreak: 'break-word',
})
